module.exports = __webpack_public_path__ + "img/114.58426c14.jpg";